$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  $('.submenu-li').parent('ul').addClass('sub-menu');
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.bannermenu-li').parent('ul').addClass('banner-menu');

  $('.slow-window').fadeOut('slow');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  $("button.navbar-toggle").on('click', function() {
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
  });

   $(".ajax-spin-cart").on('click', function() {
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    }, 1000);
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    $("body").removeClass("hidden");
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }

  // ==============================================
  // ---------- Dynamic back-to-top color (jQuery) ----------
// -------------------- Improved dynamic back-to-top color --------------------
(function($){
  function debounce(fn, wait){
    var t;
    return function(){
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  $(function(){
    var $btn = $('#top');
    if (!$btn.length) return;

    // fallback at start
    var fallback = getComputedStyle(document.documentElement).getPropertyValue('--font-color-primary') || '#b71c1c';
    $btn.css('background-color', fallback.trim());

    // center-based selection (same as previous improved version)
    function pickBestSection(){
      var $sections = $('[data-backtop]');
      if (!$sections.length) return null;

      var vpCenter = window.innerHeight / 2;
      var best = null;
      var bestScore = Infinity;

      $sections.each(function(){
        var rect = this.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

        var secCenter = rect.top + (rect.height / 2);
        var distance = Math.abs(secCenter - vpCenter);
        var visible = Math.max(0, Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top));
        var penalty = (rect.height > 0) ? (1 - (visible / rect.height)) : 1;
        var score = distance + (penalty * 1000);

        if (score < bestScore){
          bestScore = score;
          best = this;
        }
      });

      // fallback to largest visible portion if none chosen
      if (!best){
        var bestVisible = 0;
        $sections.each(function(){
          var rect = this.getBoundingClientRect();
          var visible = Math.max(0, Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top));
          if (visible > bestVisible){
            bestVisible = visible;
            best = this;
          }
        });
      }

      return best;
    }

    // Apply color immediately (fast)
    function applyImmediateColor(){
      var best = pickBestSection();
      if (!best) return;
      var color = $(best).attr('data-backtop') || $(best).data('backtop');
      if (color) $btn.css('background-color', color);
    }

    // Apply stable color after scrolling ends (locks final color)
    function applyStableColor(){
      var best = pickBestSection();
      if (!best) return;
      var color = $(best).attr('data-backtop') || $(best).data('backtop');

      // Optional: prefer footer if it has at least 18% of viewport visible
      var $best = $(best);
      var rect = best.getBoundingClientRect();
      var visible = Math.max(0, Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top));
      var visiblePct = (rect.height > 0) ? (visible / rect.height) : 0;

      if (color) {
        // If footer (or any section) has decent presence, set it; otherwise still set picked color
        if (visiblePct >= 0.18) {
          $btn.css('background-color', color);
        } else {
          // still set it — but this branch allows you to add more rules if needed
          $btn.css('background-color', color);
        }
      }
    }

    // run once on load (after small delay so layout stabilizes)
    setTimeout(applyImmediateColor, 150);

    // Scroll handling:
    var stableTimer = null;
    var immediateDebounced = debounce(applyImmediateColor, 60); // quick but debounced
    var stableDelay = 220; // ms after scroll stops to lock color (tweakable)

    $(window).on('scroll', function(){
      // immediate responsive update while scrolling
      immediateDebounced();

      // reset stable timer
      clearTimeout(stableTimer);
      stableTimer = setTimeout(function(){
        applyStableColor();
      }, stableDelay);
    });

    // also when resizing
    $(window).on('resize', debounce(function(){
      applyImmediateColor();
      clearTimeout(stableTimer);
      stableTimer = setTimeout(applyStableColor, stableDelay);
    }, 120));

    // and listen for theme editor postMessage events (Customizer)
    window.addEventListener('message', function(){ 
      applyImmediateColor();
      clearTimeout(stableTimer);
      stableTimer = setTimeout(applyStableColor, stableDelay);
    }, false);

  });
})(jQuery);

  // ==============================================

  var sticky = $('.header-bottom-wrap'),
  scroll = $(window).scrollTop();
  if (scroll >= 150) {
    sticky.addClass('is-sticky');
  }
  else {
    sticky.removeClass('is-sticky');
  }

  $('label.box-area').on('click', function () {
    if($('.cust-checkbox').is(':checked')) {
      $('.agree').removeClass('disabled');
    }
    else {
      $('.agree').addClass('disabled');
    }
  });
  
});